var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-overlay',{staticClass:"nav-bar-root",attrs:{"isOpen":_vm.isOpen},on:{"close":_vm.handleClose}})}
var staticRenderFns = []

export { render, staticRenderFns }